import styled from 'styled-components';
import * as colors from '../../common/styles/colors';
import * as mixins from '../../common/styles/mixins';

export const FAQModalWrapper = styled.div`
  .question {
    p {
      margin-bottom: 0;
    }
  }
   
  .modal-title {
    color: ${colors.hydroBlue};
  }

  .menu-wrapper {
    background-color: ${({ theme }) => theme.bg.secondary};
    border-top-right-radius: 1em;
    padding-left: 0;
  }

  .mainMenu {
    display: flex;
    flex-direction: column;
    flex: 1;
    border-top-right-radius: 1em;
    padding-top: 0.5em;
    margin: 0;
    list-style: none;

   
    margin-top: 10px;
    background-color: ${colors.white};

    & > li {

      a {
        display: flex;
        align-items: center;
        text-decoration: none;

        &:hover {
          color: ${({ theme }) => theme.text.secondary};

          svg path {
            ${mixins.transition};
            fill: ${({ theme }) => theme.text.secondary};
            stroke: ${({ theme }) => theme.text.secondary};
          }

          svg rect {
            fill: ${({ theme }) => theme.text.secondary};
          }
        }
      }

      ul {
        padding: 0;
        list-style: none;
        height: 0;
        overflow: hidden;
      }
  }
  
  .menu {
    list-style-type: none;
    padding-top: 15px;

    a {
      text-decoration: none;
    }

    .menu-link {
      display: block;
      text-align: center;

      ${mixins.respondTo.desktop`
        display: flex;
      `};
    }

    .menu-icon {
    }

    .menu-item {
      padding-left: 15px;
      text-decoration: none;

      display: none;
      ${mixins.respondTo.desktop`
        display: block;
      `};
    }
  }
`;
